<template>
  <print ref="print"></print>
</template>
<script>
import print from "@/components/common/customprint/index";
export default {
  components: { print },
  data() {
    return {
      api: require("@/api/rp/outwriteoff").default,
      data: {}
    }
  },
  mounted() {
    var josn_str = sessionStorage.getItem("outwriteoff_print");
    if (josn_str) this.data = JSON.parse(josn_str);
     console.log('params', this.data);
    var name = this.data.Params.zkfs==1?"getRpChkPayWriteOff":"getRpPayWriteOff";
    var str = JSON.stringify( this.data.Params);
      var sub = JSON.parse(str);
      if( this.data.Params.zkfs == 2) {
        sub.DocType =  this.data.Params.SrcVouType;
        sub.SrcVouDateStart =  this.data.Params.DocDateStart;
        sub.SrcVouDateEnd =  this.data.Params.DocDateEnd;
        delete sub.SrcVouType;
        delete sub.DocDateStart;
        delete sub.DocDateEnd;
      }
      var sub2 =  this.data.Params.zkfs==1? this.data.Params:sub;
      var final = {};
      for(var key in sub2) {
        if(!(typeof(sub2[key]) == "object" && sub2[key].length==0)) {
          final[key] = sub2[key];
        }
      }
    this.api[name](final).then(res => {
      if (res.Code == 0) {
        var data = {
          Title: "应付核销情况表", TableNames: this.data.TableNames, Params: this.data.Params,
          ParamsData: this.data.ParamsData, List: res.Data
        };
        this.$refs.print.setData(data);
      }
    })
  },
}
</script>